module.exports = __webpack_public_path__ + "img/logo.2993dddb.png";